/**
 * @desc WMS入库结果参数校验
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.FulfilmentInRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/fulfilment/inCheck`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
